import {chakra} from '@chakra-ui/react';
import type {HTMLChakraProps} from '@chakra-ui/system';
import {faCheck} from '@fortawesome/pro-light-svg-icons/faCheck';
import {faTimes} from '@fortawesome/pro-light-svg-icons/faTimes';
import {FontAwesomeIcon, type FontAwesomeIconProps} from '@fortawesome/react-fontawesome';
import React from 'react';

export const IconBoolean = ({value}: {value?: boolean}) => {
  const icon = value ? faCheck : faTimes;
  const color = value ? `icon.state.success-bold` : `icon.state.danger-bold`;
  return <Icon icon={icon} color={color} />;
};

const IconComponent = chakra(FontAwesomeIcon, {
  baseStyle: {
    width: `24px`,
    height: `24px`,
    fontSize: `1rem`,
  },
});

export const Icon = (props: IconProps) => {
  return <IconComponent {...props} />;
};

export type IconProps = Pick<FontAwesomeIconProps, 'icon' | 'fixedWidth'> & HTMLChakraProps<'svg'>;

export {Icon as ChakraIcon} from '@chakra-ui/react';
